import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EGAccordionSingle } from "../../../../MainComponents/Accordion/EGAccordion/EGAccordion";
import { InvolvedView } from "./InvolvedView";

export const InvolvedTypes = ({
  involvedsInInvestigation,
  involvedsInReport,
  setSelectedInvolved,
  setShowDrawer,
  setDrawerInEdit,
  onValidateSoeid,
  justView,
}) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  return (
    <Stack spacing={2} p={1}>
      <Type
        title={t("involved.victims")}
        color={theme.palette.blue.main}
        involvedsInInvestigation={involvedsInInvestigation?.victim || []}
        involvedsInReport={involvedsInReport?.victim || []}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        setDrawerInEdit={setDrawerInEdit}
        onValidateSoeid={onValidateSoeid}
        justView={justView}
      />
      <Type
        title={t("involved.accomplices")}
        color={theme.palette.blueGray600.main}
        involvedsInInvestigation={involvedsInInvestigation?.accomplice || []}
        involvedsInReport={involvedsInReport?.accomplice || []}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        setDrawerInEdit={setDrawerInEdit}
        onValidateSoeid={onValidateSoeid}
        justView={justView}
      />
      <Type
        title={t("involved.offenders")}
        color={theme.palette.red.main}
        involvedsInInvestigation={involvedsInInvestigation?.offender || []}
        involvedsInReport={involvedsInReport?.offender || []}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        setDrawerInEdit={setDrawerInEdit}
        onValidateSoeid={onValidateSoeid}
        justView={justView}
      />
      <Type
        title={t("involved.witnesses")}
        color={theme.palette.green.main}
        involvedsInInvestigation={involvedsInInvestigation?.witness || []}
        involvedsInReport={involvedsInReport?.witness || []}
        setSelectedInvolved={setSelectedInvolved}
        setShowDrawer={setShowDrawer}
        setDrawerInEdit={setDrawerInEdit}
        onValidateSoeid={onValidateSoeid}
        justView={justView}
      />
    </Stack>
  );
};

const Type = ({
  title,
  color,
  involvedsInInvestigation,
  involvedsInReport,
  setSelectedInvolved,
  setShowDrawer,
  setDrawerInEdit,
  onValidateSoeid,
  justView,
}) => {
  const theme = useTheme();

  const hasInvolved =
    involvedsInInvestigation.length > 0 || involvedsInReport.length > 0;
  if (!hasInvolved) return <></>;

  return (
    <EGAccordionSingle
      title={title}
      color={theme.palette.white.main}
      bgColor={color}
    >
      <Stack spacing={2}>
        {involvedsInReport.map((item, idx) => (
          <InvolvedView
            key={`involved-${title}-report-${idx}`}
            color={color}
            involved={item}
            setSelectedInvolved={setSelectedInvolved}
            setShowDrawer={setShowDrawer}
            setDrawerInEdit={setDrawerInEdit}
            onValidateSoeid={onValidateSoeid}
            justView={justView}
          />
        ))}
        {involvedsInInvestigation.map((item, idx) => (
          <InvolvedView
            key={`involved-${title}-investigation-${idx}`}
            index={idx}
            color={color}
            involved={item}
            setSelectedInvolved={setSelectedInvolved}
            setShowDrawer={setShowDrawer}
            setDrawerInEdit={setDrawerInEdit}
            onValidateSoeid={onValidateSoeid}
            justView={justView}
            hide={item.added}
          />
        ))}
      </Stack>
    </EGAccordionSingle>
  );
};
